import { render, staticRenderFns } from "./ListBMHC.vue?vue&type=template&id=b276b3bc&scoped=true"
import script from "./ListBMHC.vue?vue&type=script&lang=js"
export * from "./ListBMHC.vue?vue&type=script&lang=js"
import style0 from "./ListBMHC.vue?vue&type=style&index=0&id=b276b3bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b276b3bc",
  null
  
)

export default component.exports